/**
*
*   Certifications Block
*       - Animates in the Product Benefits
*
**/
'use client';

import Config from '@/config';
import Button from '@/components/button';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
//import 'swiper/css';

//Load Module
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

//Build the Element
export default function Certifications({ product, grid = true, destination, ...props }){

	//Default Reference
	const ref       = useRef();

	//Prep Translations
	const t         = useTranslations();

	//Swiper Class Reference
	const swiper    = useRef();

	//The Certifications Object
	const Certifications  = {

		//The Data
		list: [{

			//All Natural
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
					<path d="M198 19L310 146.5c1.3 1.5 2 3.4 2 5.4c0 4.5-3.6 8.1-8.1 8.1H248c-3.3 0-6.2 2-7.4 5.1s-.4 6.5 2 8.8L341.6 267c1.5 1.4 2.4 3.4 2.4 5.5c0 4.2-3.4 7.5-7.5 7.5H272c-3.3 0-6.2 2-7.4 5.1s-.4 6.5 2 8.8L365.6 387c1.5 1.4 2.4 3.4 2.4 5.5c0 4.2-3.4 7.5-7.5 7.5H235.3 200V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V400H148.7 23.5c-4.1 0-7.5-3.4-7.5-7.5c0-2.1 .9-4.1 2.4-5.5l99.1-93.2c2.4-2.2 3.2-5.7 2-8.8s-4.2-5.1-7.4-5.1H47.5c-4.2 0-7.5-3.4-7.5-7.5c0-2.1 .9-4.1 2.4-5.5l99.1-93.2c2.4-2.2 3.2-5.7 2-8.8s-4.2-5.1-7.4-5.1H80.1c-4.5 0-8.1-3.6-8.1-8.1c0-2 .7-3.9 2-5.4L186 19c3.2-3.6 8.8-3.6 12 0zM148.7 416H184v88c0 4.4 3.6 8 8 8s8-3.6 8-8V416h35.3H360.5c13 0 23.5-10.5 23.5-23.5c0-6.5-2.7-12.7-7.4-17.1L292.2 296h44.3c13 0 23.5-10.5 23.5-23.5c0-6.5-2.7-12.7-7.4-17.1L268.2 176h35.7c13.3 0 24.1-10.8 24.1-24.1c0-5.9-2.1-11.5-6-15.9L210 8.4c-9.6-10.9-26.5-10.9-36.1 0L62 135.9c-3.9 4.4-6 10.1-6 15.9C56 165.2 66.8 176 80.1 176h35.7L31.4 255.4C26.7 259.8 24 266 24 272.5c0 13 10.5 23.5 23.5 23.5H91.8L7.4 375.4C2.7 379.8 0 386 0 392.5c0 13 10.5 23.5 23.5 23.5H148.7zM429.9 8.7l-84 97.4c-2.9 3.3-2.5 8.4 .8 11.3s8.4 2.5 11.3-.8l84-97.4c3.2-3.7 8.9-3.7 12.1-.1L566 146.5c1.3 1.5 2 3.4 2 5.4c0 4.5-3.6 8.1-8.1 8.1H504c-3.3 0-6.2 2-7.4 5.1s-.4 6.5 2 8.8L597.6 267c1.5 1.4 2.4 3.4 2.4 5.5c0 4.2-3.4 7.5-7.5 7.5H528c-3.3 0-6.2 2-7.4 5.1s-.4 6.5 2 8.8L621.6 387c1.5 1.4 2.4 3.4 2.4 5.5c0 4.2-3.4 7.5-7.5 7.5H456V200c0-4.4-3.6-8-8-8s-8 3.6-8 8V504c0 4.4 3.6 8 8 8s8-3.6 8-8V416H616.5c13 0 23.5-10.5 23.5-23.5c0-6.5-2.7-12.7-7.4-17.1L548.2 296h44.3c13 0 23.5-10.5 23.5-23.5c0-6.5-2.7-12.7-7.4-17.1L524.2 176h35.7c13.3 0 24.1-10.8 24.1-24.1c0-5.9-2.1-11.5-6-15.9L466.1 8.5c-9.6-11-26.7-10.9-36.2 .2z"/>
				</svg>
			),
			title: t.rich('Pages.Product.Certifications.natural.title', Config.i18n.html ),
			description: t.rich('Pages.Product.Certifications.natural.description', Config.i18n.html )

		},{

			//Leaping Bunny
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
					<path d="M498.1 173.6l-7.4-5.1c-15.7-10.7-34.3-16.5-53.4-16.5c-2.5 0-4.9 .1-7.4 .3l-.1-.4-3.7-14.6c-11.7-46.4-46.3-83.6-91.8-98.6c-7.7-2.6-16.2-1.7-23.3 2.4l-2.1 1.2c-13.5 7.8-20 23.7-15.8 38.6l10.2 37c4.9 17.9 13.4 34.3 24.7 48.5l-80-36.3c-14.7-6.7-30.7-10.1-46.8-10.1h-9c-30.4 0-57.8 13-76.8 33.8C103.7 138.1 85 128 64 128c-35.3 0-64 28.7-64 64s28.7 64 64 64c9.7 0 19-2.2 27.2-6.1c4.6 18 13.9 34.6 27.3 47.9L182 361.3l-68.2 45.4c-18.4 12.3-23.3 37.1-11.1 55.5s37.1 23.3 55.5 11.1L239.7 419l15.9 15.9c13.5 13.5 31.8 21.1 50.9 21.1H424c22.1 0 40-17.9 40-40s-17.9-40-40-40H353.1l40-48H509.8c36.6 0 66.2-29.6 66.2-66.2c0-21.9-10.8-42.3-28.8-54.6l-34.4-23.5c8.8-51.4-8-104.3-45.7-141.3l-1.4-1.4c-7.6-7.4-18.3-10.6-28.7-8.6l-1.6 .3c-11.1 2.1-20.1 10-23.9 20.5c4.5 4.2 8.9 8.6 13 13.3c.5-2.3 1.1-4.6 1.7-6.8c1.6-5.7 6.3-10.1 12.2-11.2L440 48c5.2-1 10.6 .6 14.5 4.4l1.4 1.4c32.2 31.5 47.4 75.9 42.2 119.8zM88 224.2c0 3.1 .1 6.1 .4 9.2C81.3 237.6 72.9 240 64 240c-26.5 0-48-21.5-48-48s21.5-48 48-48c17.4 0 32.6 9.2 41 23.1c-10.8 16.4-17 36-17 57.1zM193.5 372.8l34.6 34.6L149.3 460c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l70.8-47.2zM329.3 53.9c40.3 13.3 70.9 46.2 81.3 87.4l3.7 14.6c.4 1.7 .6 3.5 .5 5.2c-.2 2.5 .9 4.9 2.8 6.6s4.4 2.3 6.9 1.8c4.1-.9 8.4-1.3 12.8-1.3c15.8 0 31.3 4.8 44.3 13.7l56.6 38.7c13.7 9.4 21.9 24.9 21.9 41.4c0 27.7-22.5 50.2-50.2 50.2H389.3c-2.4 0-4.6 1.1-6.1 2.9L336 371.5V352c0-42-25.2-79.9-64-96l-36.9-15.4c-4.1-1.7-8.8 .2-10.5 4.3s.2 8.8 4.3 10.5l36.9 15.4C298.6 284.4 320 316.5 320 352v32c0 4.4 3.6 8 8 8h24l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24H306.5c-14.9 0-29.1-5.9-39.6-16.4L129.8 286.5c-16.5-16.5-25.8-39-25.8-62.3c0-48.7 39.5-88.2 88.2-88.2h9c13.9 0 27.6 3 40.2 8.7l131.2 59.6c3.9 1.8 8.4 .2 10.4-3.6c.2-.4 .5-.9 .7-1.3c1.2-2.1 1.3-4.6 .4-6.8s-2.7-3.9-5-4.7c-.7-.2-1.4-.5-2.1-.9c-28.6-15.5-49.6-42-58.3-73.4l-10.2-37c-2.2-8 1.3-16.4 8.4-20.5l2.1-1.2c3.1-1.8 6.8-2.2 10.3-1.1zM496 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"/>
				</svg>
			),
			title: t.rich('Pages.Product.Certifications.testing.title', Config.i18n.html ),
			description: t.rich('Pages.Product.Certifications.testing.description', Config.i18n.html )

		},{

			//Sustainable Packaging
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
					<path d="M256 496C123.5 496 16 388.5 16 256c0-23.3 3.3-45.8 9.5-67.1l19.2 38.3c8.8 17.5 24.2 30.7 42.9 36.5l68.8 21.5c16.4 5.1 27.6 20.3 27.6 37.5v11.3c0 14 7.9 26.8 20.4 33c7.1 3.5 11.6 10.8 11.6 18.7v39c0 21.6 17.5 39.1 39.1 39.1c18.3 0 34.2-12.7 38.1-30.6l4.9-22.1c3.1-14.1 12.1-26.2 24.6-33.4l9-5.2c17.4-10 28.2-28.5 28.2-48.6v-8.3c0-14.9-5.9-29.1-16.4-39.6l-3.9-3.9C329.2 261.9 315 256 300.1 256H251.3c-6.2 0-12.3-1.4-17.9-4.2l-45.9-22.9c-3.6-1.8-6.6-4.8-8.4-8.4l-.7-1.4c-4.3-8.5-.8-18.9 7.7-23.2c4.1-2.1 8.9-2.4 13.2-.9l24.2 8.1c11.6 3.9 24.3-.5 31.1-10.7c6.7-10 6-23.2-1.7-32.4l-17.9-21.5c-5-6-4.9-14.7 .1-20.7l21-24.5c10.5-12.2 12.6-29.5 5.4-43.9L245.1 16.2c3.6-.2 7.3-.2 10.9-.2c87.2 0 163.5 46.5 205.5 116l-54.6 24.8c-18.6 8.5-27.9 29.6-21.4 49.1L403 258.3c4.2 12.7 14.5 22.4 27.4 25.9L491.8 301C470.7 412 373.2 496 256 496zM32.8 167.7C64.7 87.2 138.8 28 227.9 17.6l19.5 38.9c4.3 8.6 3 19-3.2 26.4l-21 24.5c-10.2 11.9-10.3 29.3-.3 41.3l17.9 21.5c3.1 3.8 3.4 9.2 .7 13.3c-2.8 4.2-8 6-12.7 4.4l-24.2-8.1c-8.4-2.8-17.5-2.1-25.4 1.8c-16.4 8.2-23.1 28.2-14.9 44.7l.7 1.4c3.4 6.7 8.8 12.2 15.6 15.6l45.9 22.9c7.8 3.9 16.4 5.9 25 5.9h48.8c10.6 0 20.8 4.2 28.3 11.7l3.9 3.9c7.5 7.5 11.7 17.7 11.7 28.3v8.3c0 14.4-7.7 27.6-20.2 34.7l-9.1 5.2c-16.5 9.4-28.2 25.3-32.3 43.8l-4.9 22.1c-2.3 10.6-11.7 18.1-22.5 18.1c-12.7 0-23.1-10.3-23.1-23.1v-39c0-14-7.9-26.8-20.4-33c-7.1-3.5-11.6-10.8-11.6-18.7V322.8c0-24.2-15.7-45.6-38.8-52.8L92.4 248.5c-14.5-4.5-26.6-14.8-33.4-28.4L32.8 167.7zM434.6 268.8c-7.7-2.1-13.9-8-16.5-15.6l-17.5-52.4c-3.9-11.7 1.7-24.4 12.8-29.4L469.4 146c17 33 26.6 70.4 26.6 110c0 9.8-.6 19.5-1.7 29.1l-59.6-16.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/>
				</svg>
			),
			title: t.rich('Pages.Product.Certifications.sustainable.title', Config.i18n.html ),
			description: t.rich('Pages.Product.Certifications.sustainable.description', Config.i18n.html )

		},{

			//Diffuser Friendly
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
					<path d="M393.6 57.7c-42.9-5.6-85.8 12.6-111.2 47.6l-20 27.5c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3l-20-27.5c-25.4-34.9-68.3-53.2-111.2-47.6C60.1 65.3 16 114.9 16 173.5c0 30.3 11.8 59.4 32.9 81.2L248 460.4c2.2 2.3 5.2 3.6 8.4 3.6s6.2-1.3 8.4-3.6L463.2 254.7c21-21.8 32.8-50.9 32.8-81.1C496 115 451.9 65.3 393.6 57.7zM269.5 95.8c28.9-39.7 77.6-60.4 126.2-54c66.1 8.6 116.3 65 116.3 131.8c0 34.4-13.4 67.5-37.2 92.2L276.2 471.5c-5.2 5.4-12.4 8.5-19.9 8.5c-7.5 0-14.7-3-19.9-8.4L37.4 265.8C13.4 241.1 0 208 0 173.5C0 106.8 50.2 50.4 116.3 41.8c48.6-6.3 97.4 14.3 126.2 54L256 114.4l13.5-18.6z"/>
				</svg>
			),
			title: t.rich('Pages.Product.Certifications.diffuser.title', Config.i18n.html ),
			description: t.rich('Pages.Product.Certifications.diffuser.description', Config.i18n.html )

		}],

		//The Swiper Settings
		Swiper: Object.assign({

			/**
			*
			*   next
			*       - Overrides default swiper to activate each slide
			*
			*   Params:
			*       n/a
			*
			**/
			onSwiper: instance => {

				//Go to Next
				swiper.current = instance;

			}

		},(()=>{

			//Swiper Params for Grid View
			if( grid ) return {
				loop: true,
				centeredSlides: true,
				spaceBetween:   10,
				slidesPerView:  1
			};

			//Default 4 column view
			return {
				slidesPerView: 1,
				loop: true,
				breakpoints: {
					800: {
						slidesPerView: 3,
						loop: true
					}
				}
			};

		})()),

		/**
		*
		*   next
		*       - Overrides default swiper to activate each slide
		*
		*   Params:
		*       n/a
		*
		**/
		next: e => {

			//Go to Next
			swiper.current.slideNext();

		},

		/**
		*
		*   previous
		*       - Overrides default swiper to activate each slide
		*
		*   Params:
		*       n/a
		*
		**/
		previous: e => {

			//Go to previous slide
			swiper.current.slidePrev();

		}
	};

	//On Mount
	useGSAP(() => {

		//Skip if it hasn't loaded
		if( !ref.current || !grid ) return;

		//Prepare the MatchMedia
		const mm = gsap.matchMedia();

		//Set Variables
		const $section      = ref.current;
		const $lists        = $section.querySelectorAll('ul');

		//
		mm.add('(min-width: 1100px)', context => {

			//Create Timeline
			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger:                $section,
					invalidateOnRefresh:    true,
					scrub:                  true,
					pin:                    true,
					pinSpacing:             true,
					markers:                false,
					start:                  'top left',
					end:                    () => {
						return `+=${
							$section.offsetHeight * 2 }`;
					}
				}
			});

			$lists.forEach(
				( $list , i ) => $list.querySelectorAll('li').forEach(
					( $item , j ) => {
						timeline.fromTo( $item , { opacity:0, yPercent: 20 },{ opacity:1, yPercent:0 } , `item${  i  }${ j }` );
					}
				)
			);

			timeline.delay( $lists.length * 50 ).fromTo( $lists , {} , {});

		});

		//
		mm.add('(min-width:501px) and (max-width: 750px)', context => {

			//Create Timeline
			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger:                $section,
					invalidateOnRefresh:    true,
					scrub:                  true,
					pin:                    false,
					markers:                false,
					once:                   true,
					start:                  '-100% left',
					end:                    '0 left'
				}
			});

			$lists.forEach(
				( $list , i ) => $list.querySelectorAll('li').forEach(
					( $item , j ) => {
						timeline.fromTo( $item , { opacity:0, yPercent: 20 },{ opacity:1, yPercent:0 } , `item${  i  }${ j }` );
					}
				)
			);

			timeline.delay( $lists.length * 50 ).fromTo( $lists , {} , {});

		});

	}, { scope: ref.current });

	//Grid Layout
	if( grid ){
		return (
			<div id="certifications" className="container isgrid" {...props} ref={ ref }>

				{/* Desktop View */}
				<div className="grid" data-viewport="desktop">
					<div className="col">
						<ul>
							<li>
								<div className="line top left"></div>
								<div className="icon">{ Certifications.list[0].icon }</div>
								<h2>{ Certifications.list[0].title }</h2>
								<p>{ Certifications.list[0].description }</p>
							</li>
							<li>
								<div className="line bottom left"></div>
								<div className="icon">{ Certifications.list[1].icon }</div>
								<h2>{ Certifications.list[1].title }</h2>
								<p>{ Certifications.list[1].description }</p>
							</li>
						</ul>
					</div>
					<div className="col">

					</div>
					<div className="col">
						<ul>
							<li>
								<div className="line top right"></div>
								<div className="icon">{ Certifications.list[2].icon }</div>
								<h2>{ Certifications.list[2].title }</h2>
								<p>{ Certifications.list[2].description }</p>
							</li>
							<li>
								<div className="line bottom right"></div>
								<div className="icon">{ Certifications.list[3].icon }</div>
								<h2>{ Certifications.list[3].title }</h2>
								<p>{ Certifications.list[3].description }</p>
							</li>
						</ul>
					</div>
				</div>

				{/* Mobile View */}
				<div data-viewport="mobile">
					<Swiper {...Certifications.Swiper} className="list">{
						Certifications.list.map( ( certification , i ) => (
							<SwiperSlide key={ i }>
								<div className="icon">{ certification.icon }</div>
								<h2>{ certification.title }</h2>
								<p>{ certification.description }</p>
							</SwiperSlide>
						))
					}</Swiper>
					<nav>
						<Button onClick={ () => Certifications.previous() }>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
								<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</Button>
						<Button onClick={ () => Certifications.next() }>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
								<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</Button>
					</nav>
				</div>

				{/* End Point for the Video Scroll */}
				<div data-destination={ Number( !!destination ) }></div>

			</div>
		);
	}

	//Full Width
	return (
		<div id="certifications" data-destination={ Number( !!destination ) } ref={ ref }>
			<div className="container" data-viewport="desktop">
				<ul className="list">{
					Certifications.list.map( ( certification , i ) => (
						<li key={ i }>
							<div className="icon">{ certification.icon }</div>
							<h2>{ certification.title }</h2>
							<p>{ certification.description }</p>
						</li>
					))
				}</ul>
			</div>
			<div data-viewport="mobile">
				<Swiper {...Certifications.Swiper} className="list">{
					Certifications.list.map( ( certification , i ) => (
						<SwiperSlide key={ i }>
							<div className="icon">{ certification.icon }</div>
							<h2>{ certification.title }</h2>
							<p>{ certification.description }</p>
						</SwiperSlide>
					))
				}</Swiper>
				<nav>
					<Button onClick={ () => Certifications.previous() }>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
							<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</Button>
					<Button onClick={ () => Certifications.next() }>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
							<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</Button>
				</nav>
			</div>
		</div>
	);

}